const sectionTypes = {
    SECTION_TOOLBAR: 'section-toolbar',
    SECTION_TITLE: 'section-title',
    SECTION_CATEGORY: 'section-category'
}

const itemTypes = {
    CATEGORY_TITLE: 'category-title',
    SUB_CATEGORY_TITLE: 'sub-category-title',
    TILES_ROW: 'tiles-row',
    TOOLBAR: 'toolbar',
    GAMES_ROW: 'games-row'
}

const categoryOperationMarketing = {
    categoryId: 'G',
    categoryName: 'En ce moment'
}

const creditCardType = {
    CB: 'CB',
    MEAL_VOUCHER: 'MEAL_VOUCHER'
}

const deliveryDropOffType = {
    DOOR: 'AT_DOOR',
    OUTSIDE: 'OUTSIDE'
}

const deliveryAddressType = {
    HOME: 'HOME',
    WORK: 'WORK',
    OTHER: 'OTHER'
}

const adyenPaymentMethods = {
    APPLE_PAY: 'applepay',
    GOOGLE_PAY: 'googlepay',
    SCHEME: 'scheme'
}

export {
    categoryOperationMarketing,
    creditCardType,
    itemTypes,
    sectionTypes,
    deliveryDropOffType,
    deliveryAddressType,
    adyenPaymentMethods
}
